
$('.product-slider').slick({
  dots: false,
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

$('.testi-slider').slick({
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});



$('.group-slider').slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 3000, 
  cssEase: 'linear',
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  pauseOnHover: false,
  pauseOnFocus: false,
  pauseOnDotsHover: false,
  draggable: false,
  touchMove: false,
  draggable: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }

  ]
});


$(document).ready(function() {
    // Jab window scroll hogi tab ye function chalega
    $(window).scroll(function() {
        // Agar page 50px se zyada scroll ho jaye
        if ($(this).scrollTop() > 50) {
            $('#shopify-section-sections--29372698787921__1778603083def57714').addClass('sticky');
        } else {
            // Jab wapas top par aa jaye
            $('#shopify-section-sections--29372698787921__1778603083def57714').removeClass('sticky');
        }
    });
});